class CartDrawer extends HTMLElement {
  connectedCallback() {
    this.overlay = this.querySelector('.cart-drawer__overlay');
    this.closeBtn = this.querySelector('[data-cart-close]');
    this.activeElement = null;
    this.handleEscape = this.handleEscape.bind(this);

    this.overlay?.addEventListener('click', () => this.close());
    this.closeBtn?.addEventListener('click', () => this.close());

    document.addEventListener('cart:open', () => this.open());
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  renderContents(parsedState) {
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = document.getElementById(section.id);
      const sectionHTML = parsedState.sections?.[section.id];

      if (!sectionElement || !sectionHTML) return;

      sectionElement.innerHTML = this.getSectionInnerHTML(sectionHTML);
    });

    this.open();
  }

  open() {
    this.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    document.body.classList.add('cart-drawer-open');
    document.addEventListener('keydown', this.handleEscape);
    this.fetchCart();
  }

  close() {
    this.classList.remove('is-open');
    document.body.style.overflow = '';
    document.body.classList.remove('cart-drawer-open');
    document.removeEventListener('keydown', this.handleEscape);
    this.activeElement?.focus?.();
  }

  handleEscape(event) {
    if (event.key === 'Escape') this.close();
  }

  async fetchCart() {
    const res = await fetch('/cart.js', { cache: 'no-store' });
    if (!res.ok) return;
    const cart = await res.json();
    this.renderItems(cart);
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  escapeHTML(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  formatMoney(amount, currency) {
    return (amount / 100).toLocaleString('en-US', {
      style: 'currency',
      currency,
    });
  }

  renderItems(cart) {
    const container = this.querySelector('[data-cart-items]');
    const subtotal = this.querySelector('[data-cart-subtotal]');
    const count = document.querySelectorAll('[data-cart-count]');

    count.forEach(el => {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? '' : 'none';
    });

    if (subtotal) {
      subtotal.textContent = this.formatMoney(cart.total_price, cart.currency);
    }

    if (!container) return;

    if (cart.items.length === 0) {
      container.innerHTML = '<p style="text-align: center; padding: 48px 24px; font-family: var(--fl-font-hype); text-transform: uppercase; opacity: 0.5;">TU COLECCIÓN ESTÁ VACÍA</p>';
      return;
    }

    container.innerHTML = cart.items.map(item => `
      <div class="cart-drawer__item" data-key="${item.key}">
        <div class="cart-drawer__item-image fl-halftone-overlay">
          ${
            item.featured_image?.url || item.image
              ? `<img src="${item.featured_image?.url || item.image}" alt="${this.escapeHTML(item.title)}" loading="lazy">`
              : ''
          }
        </div>
        <div class="cart-drawer__item-info">
          <h4 class="fl-headline cart-drawer__item-title">${this.escapeHTML(item.product_title).toUpperCase()}</h4>
          ${
            item.variant_title && item.variant_title !== 'Default Title'
              ? `<p class="fl-hype cart-drawer__item-variant">${this.escapeHTML(item.variant_title)}</p>`
              : ''
          }
          <p class="fl-hype cart-drawer__item-quantity">CANTIDAD <span>${item.quantity}</span></p>
        </div>
        <div class="cart-drawer__item-actions">
          <p class="fl-headline cart-drawer__item-price">${this.formatMoney(item.final_line_price, cart.currency)}</p>
          <p class="fl-hype cart-drawer__item-unit-price">${this.formatMoney(item.final_price, cart.currency)} C/U</p>
          <button class="cart-drawer__remove" onclick="this.closest('cart-drawer').removeItem('${item.key}')">
            <span class="material-symbols-outlined" style="color: var(--fl-red); font-variation-settings: 'FILL' 1;">delete</span>
          </button>
        </div>
      </div>
    `).join('');
  }

  async removeItem(key) {
    const itemEl = this.querySelector(`[data-key="${key}"]`);
    if (itemEl) {
      itemEl.style.transition = 'all 0.3s ease';
      itemEl.style.transform = 'scale(0.8)';
      itemEl.style.opacity = '0';
    }

    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    });
    if (!response.ok) {
      this.fetchCart();
      return;
    }

    const cart = await response.json();
    this.renderItems(cart);
  }
}

customElements.define('cart-drawer', CartDrawer);
